// extracted by mini-css-extract-plugin
export var assigneeBadge = "_im-0";
export var assigneeDetails = "_im-1";
export var assigneeInfo = "_im-2";
export var dropdownContainer = "_im-4";
export var dropdownImage = "_im-5";
export var editAssigneeInfo = "_im-3";
export var editAssigneeModalContainer = "_im-6";
export var hidden = "_im-8";
export var input = "_im-7";